<script>
  export default {
    name: "ToggleDiv",
    data: () => ({
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
    }),

    props: {
      msg: String,
    },
  };
</script>


<template>
<h1>Grundlagen</h1>
  <div align="center" class="card-wrapper">
    <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
      <h4 class="card-title">Physikalische Grundlagen zu Audio und Signalen</h4>
      <div class="card-body" align="left">
        Um (Audio-)signale besser verstehen zu können, ist es wichtig die Grundlagen zu beherrschen.
        Dazu nochmal eine kleine Wiederholung <br>

        <h5 class="pt-3">Schall</h5>
        Im Allgemeinen bezeichnet Schall eine Welle. Präziser formuliert eine mechanische Schwingung, die sich in einem elastischen Medium wie beispielsweise Luft, Gas, Flüssigkeiten oder Festkörper ausbreitet.
        Dabei wird er durch 2 wichtige physikalische Größen definiert. Zum einen der <b>Schalldruck p (in N/m2 = Pa)</b>  und zum anderen die <b>Schallschnelle v (in m/s)</b> . <br>

        <br> Für eine gute verbale Kommunikation zwischen Menschen in einem Medium wie Luft, spielt die Ausbreitungsgeschwindigkeit eine wichtige Rolle.
        Sie bestimmt mit welcher Geschwindigkeit eine physikalische Größe oder ein Zustand sich ausbreitet.
        Die Ausbreitungsgeschwindigkeit lässt sich mithilfe folgenden Formel berechnen.
        <br>
        
        <br> <b>c = λ * f</b>  <br>

        <br> f - Frequenz <br>
        <br> λ - Wellenlänge <br>
        <br>
        <br>

        <br>  Beispiel:  <br>

        <br> Ausbreitungsgeschwindigkeit <b>c</b>: Luft bei 20 Celcius: 343 m/s
        <br> Wellenlänge λ bei 20Hz: 343 m/s /20 Hz = 17m <br>
      </div>
      <button class="btn btn-primary"  @click="isShow1 = !isShow1" v-if="!isShow1">Modul abschließen</button>
    </div>

  </div> 
  
</template>

<style>
.btn {
    background-color: #528382
}
</style>